import { useEffect, useState } from "react";

import GoogleMapReact from "google-map-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import { selectColorMarker } from "../../utils/fileManagement";
import { signIn } from "../../store/actions/auth";
import {
  requestGeoLocation,
  syncDeviceLocation,
  setDevicePerc,
  updateGeo,
} from "../../store/actions/forms";
import {
  getSonviList,
  receiveSonviElement,
  updateFilteredList,
} from "../../store/actions/elements";

import NavigationButtons from "../NavigationButtons";
import FormDialog from "../ModalFilter";
import Marker from "./Marker";

export default function SimpleMap() {
  const dispatch = useDispatch();
  const { lat, lng, zoom, locationLat, locationLng } = useSelector(
    (state) => state.formElements
  );
  const { filteredList } = useSelector((state) => state.sonvi);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getSonviList());
    dispatch(setDevicePerc(0));
  }, [dispatch]);

  const markerClickHanlder = (sonviElement) => {
    dispatch(receiveSonviElement(sonviElement));
    navigate("/sonviElement");
  };

  const sonviMarkers = () => {
    if (filteredList) {
      return filteredList.map((sonviElement) => (
        <Marker
          key={`${Math.random()}-${sonviElement.lat}${sonviElement.lng}`}
          lat={sonviElement.lat}
          lng={sonviElement.lng}
          icon={selectColorMarker(sonviElement.category)}
          onClick={() => markerClickHanlder(sonviElement)}
          text="My Marker"
        />
      ));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(requestGeoLocation(name));
  };

  function createMapOptions() {
    return {
      gestureHandling: "greedy", // Will capture all touch events on the map towards map panning
    };
  }

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: "100vh", width: "100%" }}>
      <GoogleMapReact
        options={createMapOptions}
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API }}
        center={{ lat, lng }}
        onChange={(e) => {
          const { bounds } = e;
          const lngMin = bounds.nw.lng;
          const lngMax = bounds.ne.lng;
          const latMin = bounds.se.lat;
          const latMax = bounds.ne.lat;
          const userBounds = { lngMin, lngMax, latMin, latMax };
          dispatch(updateFilteredList(userBounds));
          dispatch(updateGeo(e.center.lat, e.center.lng, e.zoom));
        }}
        zoom={zoom}
      >
        <Marker
          key={`current-location`}
          lat={locationLat}
          lng={locationLng}
          icon={"/red-dot.png"}
        />
        {sonviMarkers()}
      </GoogleMapReact>
      <div
        style={{
          padding: "10px",
          borderRadius: "10px",
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          top: "40px",
          left: "50px",
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="city-search"
            label="Ciudad"
            defaultValue=""
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </Box>
      </div>
      <NavigationButtons
        handleRouteFilter={() => setModalOpen(true)}
        handleRouteUpload={() => dispatch(signIn(navigate))}
        handleSyncLocation={() => dispatch(syncDeviceLocation())}
      />
      <FormDialog
        open={modalOpen}
        handleClose={() => {
          setModalOpen(false);
        }}
      ></FormDialog>
    </div>
  );
}
